import { render, staticRenderFns } from "./workerDataWork.vue?vue&type=template&id=7953a1a6&"
import script from "./workerDataWork.vue?vue&type=script&lang=js&"
export * from "./workerDataWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports